import { Alert, List, ListGroupItem } from 'reactstrap';
import { getDashColor } from '~/shared/components/icons';
import { useState } from 'react';

function RejectionReasonAlert({ infoNote }: { infoNote: string | undefined }) {
    const [toggleAlert, setToggleAlert] = useState(true);

    const handleToggle = () => {
        setToggleAlert(false);
    };

    if (!toggleAlert) return <></>;
    return (
        <Alert
            style={{
                borderTopRightRadius: '0',
                borderBottomRightRadius: '0',
                backgroundColor: getDashColor('message'),
                borderColor: getDashColor('message'),
                boxShadow: '0 12px 24px rgba(0, 0, 0, 0.25)',
                color: 'white',
                marginRight: '-40px',
            }}
        >
            <div
                className='eyebrow'
                style={{
                    marginBottom: '18px',
                    color: 'white',
                }}
            >
                Reason for Rejection
            </div>
            {infoNote}
        </Alert>
    );
}

export default RejectionReasonAlert;
